/*365플러스 컬러별 색상 확인 슬라이드*/
const slideContainer = document.getElementById('slideContainer');
const progressBar = document.getElementById('progressBar');
const selectedColorDisplay = document.getElementById('selectedColor');

// ✅ background-image URL 방식으로 수정
const colorMap = {
  beige: {
    bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/anayo-beige.jpg)',
    name: ' ベージュ'
  },
  gray: {
    bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/anayo-gray.jpg)',
    name: ' グレー'
  },
  mint: {
    bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/anayo-mint.jpg)',
    name: ' ミント'
  },
  khaki: {
    bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/anayo-khaki.jpg)',
    name: ' カーキ'
  },
  bk: {
    bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/anayo-black.jpg)',
    name: ' ブラック'
  },
  zebra: {
    bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/zebra_2c186bb6-337e-4276-900f-32f1196e5ce5.jpg)',
    name: ' ゼブラ'
  },
  bleo: {
    bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/brown-leopard_d51a4ff1-4eeb-41ce-8ebe-fc425132fab7.jpg)',
    name: ' ブラウンレオパード'
  },
  gleo: {
    bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/gray-leopard_dabcaa90-d935-4442-89f1-781b4c9ec972.jpg)',
    name: ' グレー レオパード'
  }
};

let swiper;

function loadSlides(color) {
  slideContainer.innerHTML = '';
  for (let i = 1; i <= 6; i++) {
    const slide = document.createElement('div');
    slide.classList.add('swiper-slide');
    const padded = String(i).padStart(2, '0');
    slide.innerHTML = `<img src="https://gooseket.com/web/upload/product_detail/365plus/colorchip/365plus_${color}${padded}.jpg" alt="${color}-${i}">`;
    slideContainer.appendChild(slide);
  }
  if (swiper) swiper.destroy(true, true);
  swiper = new Swiper('.colorSwiper', {
    loop: false,
    slidesPerView: 1.5,
    spaceBetween: 10,
    grabCursor: true,
    allowTouchMove: true,
    on: {
      slideChange: () => {
        const total = swiper.slides.length;
        const progress = ((swiper.realIndex + 1) / total) * 100;
        progressBar.style.width = progress + '%';
      }
    }
  });
  progressBar.style.width = '16.6%';
}

document.querySelectorAll('.color-circle').forEach(el => {
  const color = el.getAttribute('data-color');
  const colorInfo = colorMap[color];
  if (colorInfo) {
    el.style.backgroundImage = colorInfo.bg;
    el.style.backgroundSize = 'cover';
    el.style.backgroundPosition = 'center';
  }

  el.addEventListener('click', () => {
    document.querySelector('.color-circle.active')?.classList.remove('active');
    el.classList.add('active');

    loadSlides(color);

    selectedColorDisplay.innerHTML = `
      <div class="chip" style="background-image:${colorInfo.bg}; background-size:cover;"></div>
      <span>${colorInfo.name}</span>
    `;
  });
});

document.addEventListener('DOMContentLoaded', () => {
  loadSlides('bk');
});


/*구석구석 섬세한 */

new Swiper('.structure-swiper', {
  slidesPerView: 1.5,
  spaceBetween: 20,
  grabCursor: true,
  loop: false,
  centeredSlides: false,
  slidesOffsetAfter: 40,
});

/*어디든 착_핸디백/힙색/유모차가방/무한한활용도_365플러스*/


document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.customSingleSlideSwiper', {
    slidesPerView: 1,
    loop: false,
    spaceBetween: 10,
    grabCursor: true,
    on: {
      init: function () {
        updateProgressBar(this);
      },
      slideChange: function () {
        updateProgressBar(this);
      }
    }
  });

  function updateProgressBar(swiperInstance) {
    const totalSlides = swiperInstance.slides.length;
    const percent = ((swiperInstance.activeIndex + 1) / totalSlides) * 100;

    // ✅ ID 정확히 맞춰서 수정
    const bar = document.getElementById('customProgressBar');
    if (bar) bar.style.width = percent + '%';
  }

  // ✅ 초기 바 상태 설정 (init에서 이미 호출되므로 생략 가능)
  // updateProgressBar(swiper);
});

/*어디든 착_핸디백/힙색/유모차가방/무한한활용도_365슬링백*/

 document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.customSingleSlideSwiper2', {
      slidesPerView: 1,
      spaceBetween: 10,
      grabCursor: true,
      loop: false,
      on: {
        init: function () {
          updateProgressBar(this);
        },
        slideChange: function () {
          updateProgressBar(this);
        }
      }
    });

    function updateProgressBar(swiperInstance) {
      const totalSlides = swiperInstance.slides.length;
      const percent = ((swiperInstance.activeIndex + 1) / totalSlides) * 100;
      const bar = document.getElementById('progressBarSliderOnly');
      if (bar) bar.style.width = percent + '%';
    }
  });



/*슬링백상단누끼슬라이드*/

 const chips = document.querySelectorAll('.color-circle');
    const image = document.getElementById('mainImage');
    const chipDisplay = document.querySelector('#selectedColor .chip');
    const nameDisplay = document.querySelector('#selectedColor span');

    chips.forEach(chip => {
      chip.addEventListener('click', () => {
        chips.forEach(c => c.classList.remove('active'));
        chip.classList.add('active');

        const imgSrc = chip.getAttribute('data-img');
        const colorHex = chip.getAttribute('data-hex');
        const colorName = chip.getAttribute('data-name');

        image.src = imgSrc;
        chipDisplay.style.background = colorHex;
        nameDisplay.textContent = colorName;
      });
    });


/*슬링백 누끼 컬러칩 탭메뉴_365슬링백*/

const chipsTop = document.querySelectorAll('.color-circle-top');
const imageTop = document.getElementById('mainImageTop');
const chipDisplayTop = document.querySelector('#selectedColorTop .chip-top');
const nameDisplayTop = document.querySelector('#selectedColorTop span');

chipsTop.forEach(chip => {
  chip.addEventListener('click', () => {
    chipsTop.forEach(c => c.classList.remove('active'));
    chip.classList.add('active');

    const imgSrc = chip.getAttribute('data-img');
    const colorHex = chip.getAttribute('data-hex');
    const colorName = chip.getAttribute('data-name');

    imageTop.src = imgSrc;
    chipDisplayTop.style.background = colorHex;
    nameDisplayTop.textContent = colorName;
  });
});

/*컬러별 색상을 확인하세요 슬라이드_착용샷_365힙시트 상세*/
const swipers = [];

function initColorSlider365() {
  const container = document;

  container.querySelectorAll('.swiper.colorSwiper').forEach(swiperEl => {
    const color = swiperEl.dataset.color;
    const progressBar = container.querySelector(`.progress-bar-container[data-color="${color}"] .progress-bar-fill`);

    const instance = new Swiper(swiperEl, {
      slidesPerView: 1.5,
      spaceBetween: 10,
      centeredSlides: false,
      on: {
        slideChange() {
          const total = this.slides.length - 1;
          const current = this.activeIndex;
          const percent = (current / total) * 100;
          if (progressBar) progressBar.style.width = `${percent}%`;
        },
        init() {
          this.emit('slideChange');
        }
      }
    });

    swipers.push({ color, instance });
  });

  const chips = container.querySelectorAll('.color-chip');
  chips.forEach(chip => {
    chip.addEventListener('click', () => {
      const selected = chip.dataset.color;

         // 🔥 라벨 엘리먼트 찾아서 있을 때만 업데이트
    const labelEl = document.querySelector('.color_slide_365-label');
    if (labelEl) labelEl.textContent = selected;
      
      chips.forEach(c => c.classList.remove('active'));
      chip.classList.add('active');

      container.querySelectorAll('.swiper.colorSwiper').forEach(s => {
        s.style.display = s.dataset.color === selected ? 'block' : 'none';
      });
      container.querySelectorAll('.progress-bar-container').forEach(pb => {
        pb.style.display = pb.dataset.color === selected ? 'block' : 'none';
      });

      const target = swipers.find(s => s.color === selected);
      if (target) {
        target.instance.update();
        target.instance.slideTo(0);
      }
    });
  });

  const firstChip = container.querySelector('.color-chip[data-color]');
  if (firstChip) firstChip.click();
}

document.addEventListener('DOMContentLoaded', () => {
  initColorSlider365();
});


/*아코디언 부딪힘 이슈해결*/
  const accordions = document.querySelectorAll(".accordion");

  accordions.forEach((acc, i) => {
    acc.addEventListener("click", function () {
      this.classList.toggle("active");
      const panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });


/*비디오태그 재생*/
   document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
      document.querySelectorAll('video').forEach(video => {
        if (video.offsetParent !== null) {
          video.play().catch(() => {});
        }
      });
    }, 300);
  });
  
    /* ✅ Intro 슬라이드 */
document.addEventListener('DOMContentLoaded', function () {
  const introSwiper = new Swiper('.introSwiper', {
    slidesPerView: 1,
    loop: false,
    spaceBetween: 10,
    grabCursor: true,
    on: {
      init: function () {
        updateIntroProgress(this);
      },
      slideChange: function () {
        updateIntroProgress(this);
      }
    }
  });

  function updateIntroProgress(swiperInstance) {
    const totalSlides = swiperInstance.slides.length;
    const percent = ((swiperInstance.activeIndex + 1) / totalSlides) * 100;
    const bar = document.getElementById('introProgressBar');
    if (bar) bar.style.width = percent + '%';
  }
});


/*바람막이 컬러칩 슬라이드 재수정*/
document.addEventListener('DOMContentLoaded', () => {
    const swipers = [];
    const container = document.querySelector('.color_slide_365-wrap');
    
    if (!container) return;

    container.querySelectorAll('.color_slide_365-swiper').forEach(swiperEl => {
      const color = swiperEl.dataset.color;
      const progressEl = swiperEl.nextElementSibling.querySelector('.color_slide_365-progress-fill');

      const swiper = new Swiper(swiperEl, {
        slidesPerView: 1.5,
        spaceBetween: 10,
        centeredSlides: false,
        on: {
          slideChange() {
            const total = this.slides.length - 1;
            const current = this.activeIndex;
            const percent = (current / total) * 100;
            if (progressEl) progressEl.style.width = `${percent}%`;
          },
          init() {
            this.emit('slideChange');
          }
        }
      });
      swipers.push({ color, swiper });
    });

    const chips = container.querySelectorAll('.color_slide_365-chip');
    chips.forEach(chip => {
      chip.addEventListener('click', () => {
        const selected = chip.dataset.color;
        chips.forEach(c => c.classList.remove('active'));
        chip.classList.add('active');

        container.querySelectorAll('.color_slide_365-swiper').forEach(s => {
          s.style.display = s.dataset.color === selected ? 'block' : 'none';
        });

        container.querySelectorAll('.color_slide_365-progress').forEach(p => {
          p.style.display = p.previousElementSibling.dataset.color === selected ? 'block' : 'none';
        });

        const target = swipers.find(s => s.color === selected);
        if (target) {
          target.swiper.update();
          target.swiper.slideTo(0);
        }

        container.querySelector('.color_slide_365-label').textContent = selected;
      });
    });

    const firstChip = container.querySelector('.color_slide_365-chip');
    if (firstChip) firstChip.click();
  });
/*바람막이 컬러칩 슬라이드 재수정 끝*/


/* AIR + 슬링백 상세*/
document.addEventListener('DOMContentLoaded', function () {

var airHeroEl2 = document.querySelector('.airHeroSwiper');

if (airHeroEl2 && typeof Swiper !== 'undefined') {
new Swiper(airHeroEl2, {
slidesPerView: 1,
loop: true,
speed: 600,
pagination: {
el: '.airHeroPagination',
clickable: true
}
});
}

var airUseEl = document.querySelector('.airUseSwiper');

if (airUseEl && typeof Swiper !== 'undefined') {
new Swiper(airUseEl, {
slidesPerView: 1.25,
spaceBetween: 10
});
}

});
